import Request from '@/utils/request'

// 激励活动
export function getCallMotivationCfg () {
  return Request({
    url: `/api/v2/app/incentive/home`,
    method: "get"
  });
}

// 激励活动-签到
export function signCallMotivation () {
  return Request({
    url: `/api/v2/app/incentive/sign`,
    method: "post"
  });
}

// 激励活动-领奖
export function claimCallMotivation () {
  return Request({
    url: `/api/v2/app/incentive/claim`,
    method: "post"
  });
}